import React, { useEffect, useState } from 'react';

import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel
} from '@material-ui/core';

import { useHistory } from 'react-router-dom';
import {
  NumberParam,
  StringParam,
  useQueryParam,
  withDefault
} from 'use-query-params';
import PageTemplate from '../../common/page-template/PageTemplate';
import PageTemplateCardOver from '../../common/page-template/PageTemplateCardOver';
import PageTemplateHeader, {
  PageTemplateHeaderActions
} from '../../common/page-template/PageTemplateHeader';
import SearchBox from '../../common/SearchBox';
import { useFindGroups } from './Group.hooks';
import GroupCreateDialog from './GroupCreateDialog';

const GroupListPage: React.FC = () => {
  const [page, setPage] = useQueryParam('page', withDefault(NumberParam, 0));
  const [limit, setLimit] = useQueryParam(
    'limit',
    withDefault(NumberParam, 100)
  );
  const [order, setOrder] = useQueryParam('order', StringParam);
  const [orderDirection, setOrderDirection] = useQueryParam(
    'direction',
    StringParam
  );

  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const history = useHistory();
  const [search, setSearch] = useState('');
  const { groupList, get } = useFindGroups(true);

  useEffect(() => {
    const params = {
      filter: search,
      page: page,
      limit: limit,
      order: String(order || '')
    } as any;
    if (order && orderDirection) {
      params.order = `${order} ${orderDirection}`;
    }
    get(params);
  }, [get, page, limit, order, orderDirection, search]);

  const handleSort = (column: string) => {
    setOrder(column);
    setOrderDirection(orderDirection === 'ASC' ? 'DESC' : 'ASC');
  };

  const getSortDirection = (column: string): 'asc' | 'desc' => {
    return order === column && orderDirection === 'DESC' ? 'desc' : 'asc';
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setLimit(+event.target.value);
    setPage(0);
  };

  return (
    <PageTemplate>
      <PageTemplateHeader>
        <h2>Teams</h2>
        <SearchBox value={search} onSearch={value => setSearch(value)} />
        <PageTemplateHeaderActions>
          <Button
            variant='contained'
            color='primary'
            onClick={() => setIsOpenDialog(true)}
          >
            Add Team
          </Button>
        </PageTemplateHeaderActions>
      </PageTemplateHeader>
      <PageTemplateCardOver>
        <TableContainer>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>
                  <TableSortLabel
                    active={order === 'name'}
                    direction={getSortDirection('name')}
                    onClick={() => handleSort('name')}
                  >
                    Name
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={order === 'description'}
                    direction={getSortDirection('description')}
                    onClick={() => handleSort('description')}
                  >
                    Description
                  </TableSortLabel>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {groupList &&
                groupList.data.map(group => (
                  <TableRow
                    hover
                    key={group.id}
                    // component={Link}
                    // to={transform(`/portal/groups/${group.id}`)}
                    onClick={() => {
                      history.push(`/portal/groups/${group.id}`);
                    }}
                  >
                    <TableCell>{group.name}</TableCell>
                    <TableCell>{group.description}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component='div'
          count={groupList?.total || 0}
          rowsPerPage={limit}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowPerPage}
        />
      </PageTemplateCardOver>

      {isOpenDialog && (
        <GroupCreateDialog
          open={isOpenDialog}
          onCancel={() => setIsOpenDialog(false)}
          onCreated={() => {
            setIsOpenDialog(false);
            get(); // refresh data
          }}
        />
      )}
    </PageTemplate>
  );
};

export default GroupListPage;
